import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import FOODGALLERY from "../../Assets/Projects/foodGallery.png";
import imgg from "../../Assets/logg.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          Recent <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Recent projects I've worked on.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={FOODGALLERY}
              title="Food Gallery"
              description="A Backend web app for fully functional Add to cart service.. "
              tech="Technology Includes:
              React , mongodb , express and nodejs.."
              test=""
              git="https://github.com/muazz056/sp20-bcs-056/tree/main/Semester%20Web%20Project%20Food%20Gallery"

            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={imgg}
              title="Portfolio Website"
              description="It is a react based portfolio website.. "
              tech="Technology Includes:
              React , Css , JavaScript.."
              test=""
              git=""

            />
          </Col>


        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
